// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar__1EUcr","calendar__title":"calendar__title__3x1tY","calendar__main":"calendar__main__i74zH"};